export default "__VITE_ASSET__CpDQI$UO__"